import { useTranslation } from 'react-i18next';

import {
  HelpCenterContentDefinition,
  HelpCenterContentMeta,
  HelpCenterLocale,
} from './types';

export const resolveHelpCenterLocale = (language?: string): HelpCenterLocale => {
  if (language?.split('-')[0] === 'en') return 'en';

  return 'pt';
};

export const useHelpCenterLocale = <T,>(
  translations: Record<HelpCenterLocale, T>,
): T => {
  const { i18n } = useTranslation();

  return translations[resolveHelpCenterLocale(i18n.resolvedLanguage ?? i18n.language)];
};

export const getLocalizedHelpCenterMeta = (
  definition: HelpCenterContentDefinition,
  language?: string,
): HelpCenterContentMeta => definition.meta[resolveHelpCenterLocale(language)];

export const getLocalizedHelpCenterKeywords = (
  definition: HelpCenterContentDefinition,
  language?: string,
): string[] => (definition.keywords
  ? definition.keywords[resolveHelpCenterLocale(language)]
  : []);
